import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引入 Ant Design Vue
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

// 引入 AOS 动画库
import AOS from 'aos'
import 'aos/dist/aos.css'

// 引入全局样式
import './assets/styles/global.css'

// 引入 Animate.css
import 'animate.css'

Vue.use(Antd)
Vue.use(AOS)

// 初始化 AOS（在 Vue mounted 钩子中触发）
AOS.init({
  duration: 600,
  easing: 'ease-in-out',
  once: true,
  offset: 100
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
